import { memo } from 'react'
import { useScreenSizeUp } from 'hooks/useScreenSize'
import ChatHotelCarouselDesktopFilters from './ChatHotelCarouselDesktopFilters'
import ChatHotelCarouselMobileFilters from './ChatHotelCarouselMobileFilters'
import type { ChatHotelCarouselFiltersProps } from './ChatHotelCarouselFilters.types'

interface Props extends ChatHotelCarouselFiltersProps {}

function ChatHotelCarouselFilters(props: Props) {
  const isDesktopFilterPicker = useScreenSizeUp('tablet')

  if (isDesktopFilterPicker) {
    return <ChatHotelCarouselDesktopFilters {...props} />
  }

  return <ChatHotelCarouselMobileFilters {...props} />
}

export default memo(ChatHotelCarouselFilters)
